/** Helpers for Smart Search step-1 destination carousel (mobile coverflow + peek clones). */

export const SMART_SEARCH_MOBILE_CAROUSEL_MQ = "(max-width: 900px)";

function pickMobileCarouselDestinations(destinations) {
  if (!destinations?.length) return [];

  const cities = destinations.filter(
    (item) => item.cityId || String(item.id).startsWith("city-")
  );
  if (cities.length >= 3) return cities;

  const withImages = destinations.filter((item) => item.image);
  if (withImages.length >= 3) return withImages;

  return destinations;
}

export function buildMobileDestinationSlides(destinations) {
  const list = pickMobileCarouselDestinations(destinations);
  if (!list.length) return [];

  return list.map((item, index) => ({
    item,
    realIndex: index,
    key: `dest-${item.id}-${index}`,
  }));
}

export function buildDesktopDestinationSlides(destinations) {
  return destinations.map((item, index) => ({
    item,
    realIndex: index,
    key: `${item.id}-${item.label}`,
  }));
}

export function realIndexToDomIndex(realIndex, count, isMobile) {
  if (!count) return 0;
  const safe = Math.max(0, Math.min(realIndex, count - 1));
  return isMobile && count > 1 ? safe + 1 : safe;
}
